export const MAX_FIELDS_COUNT = 10

export const EmptyAssignee = {
  group_id: null,
  user_id: null,
}
